import wx from 'weixin-js-sdk';

export const weixin_share=(data)=>{
    //data：从后台获取的微信签名包
    let appId = data.appId;
    let timestamp = data.timestamp.toString();
    let nonceStr = data.nonceStr;
    let signature = data.signature;

    let share_title=data.share_title;
    let share_desc=data.share_desc;
    let share_link=data.share_link;
    let share_imgUrl=data.share_imgUrl;
    // console.log('appId:',appId);
    // console.log('timestamp:',timestamp);
    // console.log('nonceStr:',nonceStr);
    // console.log('signature:',signature);
    // console.log('当前url:',window.location.href);

    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature,// 必填，签名
        jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareWeibo'
        ] // 必填，需要使用的JS接口列表
    });

    //检测函数
    // wx.checkJsApi({
    //     jsApiList: ['updateAppMessageShareData','updateTimelineShareData','onMenuShareWeibo'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    //     success: function(res) {
    //         // 以键值对的形式返回，可用的api值true，不可用为false
    //         // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
    //         console.log('检测结果',res);
    //     }
    // });

    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_imgUrl, // 分享图标
            success: function () {
                // 设置成功
                console.log('分享给朋友设置成功！');
            }
        })
    });

    //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
        wx.updateTimelineShareData({
            title: share_desc, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_imgUrl, // 分享图标
            success: function () {
                // 设置成功
                console.log('分享到朋友圈设置成功！');
            }
        })
    });

    wx.error(res=>{
        console.log('微信config信息验证失败',res);
    });
};
